import React, { useEffect, useMemo, useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment-timezone';
import ContextMenu from '../../../../Scheduler/ContextMenu';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import Loader from '../../../../shared/Loader/Loader';
import useHandleOpenNewBrowserTab from '../../../../shared/NewTabBrowser/useHandleOpenNewBrowserTab';
import HandleStatus from '../../../../shared/HandleStatus';
import isNull from '../../../../../utils/NullChecking';
import DaySchedulePopup from '../../../../Patient/PatientDetails/PatientCalendar/DaySchedulePopup/DaySchedulePopup';

const CaregiverCalendarSummary = () => {

    const localizer = momentLocalizer(moment);
    const API_URL = enumUtil.controller.PATIENT;
    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    let CaregiverIDR = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    CaregiverIDR = CaregiverIDR?.data?.id
    const [isLoading, setIsLoading] = useState(false);
    const [AppointmetnData, SetAppointmentData] = useState([]);
    const [selectedAppointmentData, setSelectedAppointmentData] = useState({})
    const [isMasterWeekOpen, setIsMasterWeekOpen] = useState(false);
    const [masterWeekID, setMasterWeekID] = useState(0)
    const [PatientID, setPatientID] = useState(0)
    const [currentDate, setCurrentDate] = useState(new Date());

    const formats = {
        timeGutterFormat: 'ha', // '7AM';
        weekdayFormat: 'dddd',
        dateFormat: 'DD',
        dayFormat: 'dddd',
    }

    const handleBreakTime = (time, date) => {
        let TimeNullCheck = isNull(time);
        let DateNullCheck = isNull(date);

        if (TimeNullCheck || DateNullCheck) {
            return "";
        }
        const { hours, minutes } = convertTo24Hour("11:00 PM")

        const formatedHours = String(hours).padStart(2, '0')

        const day = date.split('/')[1];
        const month = (date.split('/')[0] - 1);
        const year = date.split('/')[2];
        const formatedDate = new Date(year, month, day, formatedHours, minutes);
        return formatedDate;

    }

    function convertTo24Hour(time) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    // const EventComponent = useMemo(() => {

    //     return ({ event }) => (

    //         <div className={`calender-inner-popup ${event?.data?.ValidationMsg ? 'else' : ''}`}>
    //             <div className="d-flex justify-content-between align-items-center br-bottom-1 br-clr-light pb-2">
    //                 {/* <p className="heading d-flex align-items-center gap-1" onClick={() => handleOpenNewBrowserTab(event?.subScreenData)}> */}
    //                     <i className="icon-Vector-6"></i> S.T: {event?.data?.STStart} to {event?.data?.STEnd}
    //                 </p>
    //                 <div className="icon-copy position-relative">
    //                     <i className="bi bi-info-circle-fill fs-15"></i>
    //                     <p class="tool_tip xsm_text text-light">
    //                         {event?.data?.ValidationMsg}
    //                     </p>
    //                 </div>
    //             </div>
    //             <div onClick={() => handleOpenNewBrowserTab(event?.ClaimSubScreenData)}>
    //                 <div className=" d-flex justify-content-between align-items-center py-2">
    //                     {/* <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-call fs-14'></i>V.T: <span className='green-text'>08:00</span> to <span className='red-text'>10:02 </span> </p> */}
    //                     {/* <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-locat fs-14'></i>V.T: <span className='green-text'>08:00</span> to <span className='red-text'>10:02 </span> </p> */}
    //                     <p className="text arlight-color d-flex align-items-center">
    //                         {" "}
    //                         <i className="icon-Vector123 fs-14"></i>V.T:{" "}
    //                         <span className="green-text">08:00</span> to{" "}
    //                         <span className="red-text">10:02 </span>{" "}
    //                     </p>
    //                     <p className="text fs-9 ar-light-color">5H 30 M</p>
    //                 </div>
    //                 <p className="text fs-11">
    //                     <span className="font-m">Hrs:</span> 4.00{" "}
    //                     <span className="font-m">Units:</span> 16
    //                 </p>

    //             </div>
    //             <div className="d-flex align-items-center justify-content-between" onClick={() => handleOpenNewBrowserTab(event?.CaregiverSubScreenData)}>
    //                 <p className="text arlight-color cursor-pointer" >{event?.data?.PatientName}</p>
    //                 <p className="Submitted text fst-italic fs-10">{event?.data?.BillingStatus}</p>
    //             </div>
    //             {console.log("handleOpenNewBrowserTab", event?.ClaimSubScreenData, event?.CaregiverSubScreenData)}
    //         </div>
    //     );
    // }, []);

    const handleAppointment = (dataArray, date) => {
        let updatedArray = []
        if (dataArray?.length > 0) {
            updatedArray = dataArray?.map((appointment) => {

                let ClaimSubScreenData = {

                    name: 'Claims',
                    data: {
                        id: appointment?.ClaimID + "",
                        name: appointment?.PatientName,
                        VisitType: appointment?.ClaimType,
                        ClaimRecord: { ID: appointment?.ClaimID + "", name: appointment?.PatientName, ClaimType: appointment?.ClaimType, EncounterID: appointment.EncounterID + ""   },
                    }
                };

                let PatientSubScreenData = {
                    name: 'Patient',
                    data: {
                        id: appointment?.PatientID,
                        name: appointment?.PatientName,
                    }
                };
                return {
                    title: (
                        <>
                            {
                                // filteredArray?.length > 1 ?


                                //     <div className={`calender-inner-popup ${appointment?.ValidationMsg ? 'else' : ''}`} onMouseEnter={(e) => hanleOnHoverPopup(e, appointment)}>
                                //         {appointment?.PatientAppointmentID &&
                                //             <div className="d-flex justify-content-between align-items-center br-bottom-1 br-clr-light pb-2px" onClick={() => handleOpenMasterWeek(appointment)}>
                                //                 <p className="heading font-m za-blue-clr ">S.T: {" " + appointment?.STStart + " "} to {" " + appointment?.STEnd + " "}</p>


                                //             </div>

                                //         }

                                //         {appointment?.ClaimID &&
                                //             <div onClick={() => appointment?.ClaimID && handleOpenNewBrowserTab(ClaimSubScreenData)}>
                                //                 <div className=" d-flex justify-content-between align-items-center py-2px px-2px" >
                                //                     <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-call fs-14'></i> <span className='font-m'>V.T: &nbsp;</span> <span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p>
                                //                     <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-locat fs-14'></i><span className='font-m'>V.T: &nbsp;</span><span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p>
                                //                     <p className="text arlight-color d-flex align-items-center">
                                //                         <i className="icon-Vector123 fs-11 fot-m"></i> <span className='font-m'>V.T: &nbsp;</span> <span className="green-text font-r">{appointment?.VTStart}</span>&nbsp;-&nbsp;<span className="red-text font-r">{appointment?.VTEnd}</span>

                                //                     </p>

                                //                 </div>

                                //                 {appointment?.ClaimCareGiverID &&
                                //                     <div className="d-flex justify-content-between align-items-center px-2px pb-2px" >
                                //                         <p className="text fs-11">{appointment?.VTTime}|{appointment?.Units ? appointment?.Units + " U " : ""}</p>
                                //                         <p className="text fs-11" onClick={(e) => { e.stopPropagation(); handleOpenNewBrowserTab(CaregiverSubScreenData) }}>{appointment?.ClaimCareGiverFirstName}</p>
                                //                     </div>}
                                //                 <div className="d-flex align-items-center justify-content-between">
                                //                     <p className='Paid heading ar-status-clm'>{appointment?.BillingStatus}</p>
                                //                     {appointment?.ValidationMsg && <div className="icon-copy position-relative">
                                //                         <i className="bi bi-info-circle-fill fs-13"></i>
                                //                         <p class="tool_tip xsm_text text-light">{appointment?.ValidationMsg}</p>
                                //                     </div>}
                                //                 </div>
                                //             </div>
                                //         }
                                //     </div>
                                //     :

                                <div className={`calender-inner-popup  position-relative ${appointment?.ValidationMsg ? 'else' : ''}`}>

                                    {appointment?.PatientAppointmentID &&
                                        <div className="d-flex justify-content-between align-items-center" onClick={() => handleOpenMasterWeek(appointment)}>
                                            <p className="heading font-m za-blue-clr ">S.T: {" " + appointment?.STStart + " "} - {" " + appointment?.STEnd + " "}</p>

                                        </div>

                                    }

                                    {appointment?.ClaimID &&
                                        <div className={appointment?.PatientAppointmentID && `br-top-1 br-clr-light`} onClick={() => appointment?.ClaimID && handleOpenNewBrowserTab(ClaimSubScreenData)}>

                                            <div className=" d-flex justify-content-between align-items-center py-2px px-2px" >
                                                {/* <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-call fs-14'></i><span className='font-m'>V.T: &nbsp;</span> <span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p> */}
                                                {/* <p className='text arlight-color d-flex align-items-center'> <i className='icon-cal-locat fs-14'></i><span className='font-m'>V.T: &nbsp;</span><span className='green-text font-r'>08:00</span>&nbsp; - &nbsp;<span className='red-text font-r'>10:02 </span> </p> */}
                                                <p className="text arlight-color d-flex align-items-center">
                                                    <i className="icon-Vector123 fs-11 fot-m"></i><span className='font-m'>V.T: &nbsp;</span><span className="green-text font-r">{appointment?.VTStart}</span>&nbsp;-&nbsp;<span className="red-text font-r">{appointment?.VTEnd}</span>

                                                </p>

                                            </div>


                                            <div className="d-flex justify-content-between align-items-center px-2px pb-2px" >
                                                <p className="text fs-11">{appointment?.VTTime} | {appointment?.Units ? appointment?.Units + " U " : ""} </p>
                                                {appointment?.PatientID && <p className="text arlight-color cursor-pointer ammount-text" onClick={(e) => { e.stopPropagation(); handleOpenNewBrowserTab(PatientSubScreenData) }}>{appointment?.PatientName}</p>}

                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                {/* <p className='Paid heading ar-status-clm'>{HandleStatus(appointment?.BillingStatus)}</p> */}
                                                <p className='Paid heading ar-status-clm'><HandleStatus Status={appointment?.BillingStatus} /></p>
                                                {appointment?.ValidationMsg && <div className="icon-copy position-relative">
                                                    <i className="bi bi-info-circle-fill fs-13"></i>
                                                    <p class="tool_tip xsm_text text-light">{appointment?.ValidationMsg}</p>
                                                </div>}
                                            </div>
                                        </div>
                                    }

                                    {/* <div className="appointment-card Processing">
                                        <div className="appointment-card__head">
                                            <div className="appointment-card__head__avatar">
                                                <img
                                                    src="https://www.w3schools.com/howto/img_avatar.png"
                                                    alt="avatar"
                                                />
                                            </div>
                                            <div className="appointment-card__head__info">
                                                <div className="d-flex justify-content-between align-items-center w-100">
                                                    <p className="heading fs-11 drk-green-clr">{appointment?.PatientName}</p>
                                                    <p className="text font-m fs-11 fst-italic ar-light-color">{appointment?.AccountNumber}</p>
                                                </div>
                                                <p className="text font-m fs-11 fst-italic drk-green-clr">{appointment?.PrimaryInsurance}</p>
                                                <div className="d-flex align-items-center gap col-md-8">
                                                    <p className="heading fs-10 ar-light-color">Medicaid #</p>
                                                    <p className="text font-m fs-10">{appointment?.MedicaidNo}</p>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex align-items-center col-md-9 gap-01">
                                                        <p className="heading fs-10 ar-light-color">Member ID:</p>
                                                        <p className="text font-m fs-10">{appointment?.MemberID}</p>
                                                    </div>
                                                    <div className="d-flex align-items-center col-md-3">
                                                        <p className="heading fs-10 ar-light-color text-nowrap">Auth # 1234</p>
                                                        <p className="text font-m fs-10">{appointment?.Auth}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="appointment-card__body">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="col-md-5 d-flex align-items-center justify-content-between">
                                                    <p className="text fs-11 font-m drk-green-clr">Schedule </p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.AppointmentDate}</p>
                                                </div>
                                                <div className="col-md-5 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Duration</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.STTime}</p>
                                                </div>

                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="col-md-5 d-flex align-items-center justify-content-between">
                                                    <p className="text fs-11 font-m drk-green-clr">Visit </p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.VisitDate}</p>
                                                </div>
                                                <div className="col-md-5 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Duration</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.VTTime}</p>
                                                </div>
                                                <div className="col-md-2 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Unit</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.Units}</p>
                                                </div>

                                            </div>
                                            <div className="">
                                                <div className="col-md-8 d-flex align-items-center justify-content-between">
                                                    <p className="text fs-11 font-m drk-green-clr">Caregiver</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.ClaimCareGiver}</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="col-md-5 d-flex align-items-center justify-content-between gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Submitted  </p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.SubmittedDate}</p>
                                                </div>
                                                <div className="col-md-5 d-flex align-items-center gap-2">
                                                    <p className="text fs-11 font-m drk-green-clr">Batch #</p>
                                                    <p className="text fs-10 font-m ar-light-color">{appointment?.EDIClaimBatchID}</p>
                                                </div>

                                            </div>

                                            <div className="appointment-card__body__item">
                                                <p className="heading fs-11 drk-green-clr">ICD(s)</p>
                                                {appointment?.ICDS && <div className="success-pill mt-1">
                                                    <p className="heading fs-9 text-white">  {appointment?.ICDS}</p>
                                                </div>}
                                                <p className="heading fs-11 drk-green-clr mt-1">CPT(s)</p>
                                                <div className="success-pill mt-1 d-flex align-items-center gap-01">
                                                    <p className="text font-m fs-9 text-white"><span className="heading fs-9 text-white">A089 </span> | Amt: <span className="heading fs-9 text-white"> $0.00</span> | Paid Amt: <span className="heading fs-9 text-white">$0.00 </span> | Status:</p>

                                                    <p className='Paid heading ar-status-clm'>Paid</p>
                                                </div>
                                                <div className="success-pill mt-1 d-flex align-items-center gap-01">
                                                    <p className="text font-m fs-9 text-white"><span className="heading fs-9 text-white">A089 </span> | Amt: <span className="heading fs-9 text-white"> $0.00</span> | Paid Amt: <span className="heading fs-9 text-white">$0.00 </span> | Status:</p>

                                                    <p className='Paid heading ar-status-clm'>Paid</p>
                                                </div>
                                                <div className="d-flex gap-01">
                                                    <p className="text font-m fs-11 drk-green-clr ">Notes:</p>
                                                    <p className="text fs-10 font-r ar-light-color text-nowrap validation_message">Lorem Ipsum xbsb hsajdh lorem jahjs kjkjak hs Lorem Ipsum xbsb hsajdh lorem jahjs kjkjak hsy....</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                </div>
                            }


                        </>

                    ),
                    start: appointment?.PatientAppointmentID ? appointment?.AppointmentTimeFrom : handleBreakTime(appointment?.VTStart, appointment?.VisitDate),
                    end: appointment?.PatientAppointmentID ? appointment?.AppointmentTimeTo : handleBreakTime(appointment?.VTEnd, appointment?.VisitDate),
                    data: {
                        PatientName: appointment?.PatientName,
                        VisitDate: appointment?.VisitDate,
                        VisitStart: appointment?.VisitStart,
                        BillingStatus: appointment?.BillingStatus,
                        STEnd: appointment?.STEnd,
                        STStart: appointment?.STStart,
                        ClaimCareGiver: appointment?.ClaimCareGiver,
                        ValidationMsg: appointment?.ValidationMsg
                    },

                }
            })
        }
        return updatedArray
    }

    const events = useMemo(() => {
        let data = handleAppointment(AppointmetnData, currentDate);
        // console.log("data", data)
        return data
    }, [AppointmetnData])
    // [
    //     {
    //         title: (
    //             <div className='calender-inner-popup'>
    //                 <div className='d-flex justify-content-between align-items-center br-bottom-1 br-clr-light pb-2'>
    //                     <p className='heading'>S.T: 08:00 to 10:00</p>
    //                     <p className='text fst-italic font-m fs-10 Submitted'>Submitted</p>
    //                 </div>
    //                 <p className='text arlight-color py-2'>V.T: <span className='green-text'>08:00</span> to <span className='red-text'>10:02 </span> </p>
    //                 <p className='text arlight-color text-decoration-underline'>Clay Anderson</p>
    //                 <div className="text-end pe-1 icon-copy position-relative">
    //                     <i className='bi bi-info-circle-fill fs-15'></i>
    //                     <p class="tool_tip xsm_text text-light">Memberid is Missing  </p>
    //                 </div>
    //             </div>),
    //         start: new Date(2024, 4, 27, 11, 0),
    //         end: new Date(2024, 4, 27, 12, 0),
    //     },

    //     {
    //         title: (
    //             <div className='calender-inner-popup'>
    //                 <div className='d-flex justify-content-between align-items-center br-bottom-1 br-clr-light pb-2'>
    //                     <p className='heading'>S.T: 08:00 to 10:00</p>
    //                     <p className='text fst-italic font-m fs-10 Submitted'>Submitted</p>
    //                 </div>
    //                 <p className='text arlight-color py-2'>V.T: <span className='green-text'>08:00</span> to <span className='red-text'>10:02 </span> </p>
    //                 <p className='text arlight-color text-decoration-underline'>Clay Anderson</p>
    //                 <div className="text-end pe-1 icon-copy position-relative">
    //                     <i className='bi bi-info-circle-fill fs-15'></i>
    //                     <p class="tool_tip xsm_text text-light">Memberid is Missing  </p>
    //                 </div>
    //             </div>),
    //         start: new Date(2024, 4, 27, 11, 0),
    //         end: new Date(2024, 4, 27, 12, 0),
    //     },

    // ];

    let initialContext = {
        event: null,
        show: false,
        x: 0,
        y: 0,
    }
    ///////////////////////////
    const [contextMenuProvider, setContextMenuProvider] = useState(initialContext);
    const [myEvents, setEvents] = useState(events)

    const handleNextWeek = () => {
        const nextMonth = moment(currentDate).add(1, 'month').toDate();
        setCurrentDate(nextMonth);
    }
    const handlePrevWeek = () => {
        const prevMonth = moment(currentDate).subtract(1, 'month').toDate();
        setCurrentDate(prevMonth);
    }
    const handleNavigate = (date) => {
        setCurrentDate(date);
    }

    const handleContextMenu = (e, prov, event, type) => {
        e.preventDefault();
        const xPos = e.clientX + 130;
        const yPos = e.clientY + 20;
        setContextMenuProvider({ event: event, show: true, x: xPos, y: yPos });
        // if (type === "timeSlotWrapper") {
        //     let Time = formateTime(event);

        //     if (Time) {
        //         setBlockPropsModal(prev => ({ ...prev, StartTime: Time }));
        //     }

        // } else if (type === "eventWrapper") {
        if (event?.data) {
            // setLocationID(event.data?.LocationID);
            // setPatientID(event?.data?.PatientAppointmentID);
        }
        // }


    }

    const handleOpenMasterWeek = (data) => {

        setIsMasterWeekOpen(true);
        setMasterWeekID(data?.PatientAppointmentID);
        setPatientID(data?.PatientID)
        setSelectedAppointmentData(data);
    }

    const onCloseMasterWeek = () => {
        setIsMasterWeekOpen(false);
    }

    const onCloseMasterWeekSave = () => {
        setIsMasterWeekOpen(false);
        LoadData()
    }

    let MasterWeekPopup = "";
    if (isMasterWeekOpen) {
        MasterWeekPopup = <DaySchedulePopup isMasterWeekOpen={isMasterWeekOpen} onClose={onCloseMasterWeek} onCloseSave={onCloseMasterWeekSave} ID={masterWeekID} patientID={PatientID} data={selectedAppointmentData} />
    }

    const LoadData = () => {
        SetAppointmentData([])
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.PatientCalendar,
            "SearchCriteria": {
                "PatientID": null,
                "PatientIDs": null,
                "CareGiverID": CaregiverIDR + "",
                "CareGiverIDs": null,
                "Year": currentDate.getFullYear() + '',
                "Month": currentDate.getMonth() + 1 + '',
                "Datefrom": null,
                "DateTo": null
            }
        }
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/CalendarDetails', 'post', saveModal)
            .then((response) => {
                setIsLoading(false);
                SetAppointmentData(response)
                // console.log("repsonse", response)
            }).catch((error) => {
                setIsLoading(false);
                SetAppointmentData([])
                // console.log("error", error)
            })
    }

    useEffect(() => {
        LoadData();
    }, [currentDate])

    return (
        <div className=' position-relative'>
            {isLoading ? <Loader /> : <></>}
            {MasterWeekPopup}
            <div className='ar_header'>
                <p className='heading fs-13'>Calendar</p>
            </div>
            <div className='ar-top-btn-position d-flex align-items-center'>
                {/* <div className='side-view h-100'></div> */}
                <div className='d-flex align-items-center gap-15 ms-2'>
                    <>
                        <span className='heading'>
                            {moment(currentDate).format('MMMM YY')}
                        </span>
                    </>
                    <div className='d-flex align-items-center gap-10'>
                        <i className='icon-angle-left me-1 fs-11 cursor-pointer' onClick={handlePrevWeek}></i>
                        <i className='icon-angle-right fs-11 cursor-pointer' onClick={handleNextWeek}></i>
                    </div>
                </div>
            </div>
            {contextMenuProvider.show ? <ContextMenu contextMenuProvider={contextMenuProvider} setContextMenuProvider={setContextMenuProvider} /> : null}
            <div className='hk-EA-calender'>
                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 750 }}
                    defaultView={"month"}
                    formats={formats}
                    date={currentDate}
                    toolbar={false}
                    tooltipAccessor={null}
                    components={{
                        // event: EventComponent,
                        eventWrapper: ({ event, children }) => (
                            <div className='events'

                                onContextMenu={
                                    e => {
                                        handleContextMenu(e, event, "eventWrapper");
                                        e.preventDefault();
                                    }
                                }
                            >
                                {children}

                            </div>
                        ),
                        // timeSlotWrapper: ({
                        //     children,
                        //     value,
                        //     resource,
                        // }) => {
                        //     return React.cloneElement(children, {
                        //         // children: (
                        //         //     <>
                        //         //         {/* Your dynamic content goes here */}
                        //         //         <p>{handleSteps(list.value)}!</p>
                        //         //         {children.props.children}
                        //         //     </>
                        //         // ),
                        //         onContextMenu: (e) => {
                        //             e.preventDefault();
                        //             handleContextMenu(e,  value, "timeSlotWrapper");
                        //         },
                        //     });

                        // },
                        // timeGutterWrapper: CustomTimeGutterWrapper,
                    }
                    }
                />
            </div>
        </div >
    )
}

export default CaregiverCalendarSummary
